import { measureText } from '../../smithchart/utils/helper';
export class AreaBounds {
    calculateAreaBounds(smithchart, title, bounds) {
        const margin = smithchart.margin;
        const border = smithchart.border;
        const spaceValue = this.getLegendSpace(smithchart, bounds);
        const x = spaceValue['leftLegendWidth'] + margin.left + border.width;
        const rightSpace = spaceValue['rightLegendWidth'] + margin.left + margin.right + (2 * border.width);
        const width = smithchart.availableSize['width'] - (x + rightSpace);
        const y = margin['top'] + (2 * smithchart.elementSpacing) + spaceValue['modelTitleHeight'] +
            spaceValue['modelsubTitleHeight'] + spaceValue['topLegendHeight'] + border.width;
        const height = smithchart.availableSize['height'] - (spaceValue['modelTitleHeight'] +
            (2 * smithchart.elementSpacing) + spaceValue['modelsubTitleHeight'] + margin['top'] +
            spaceValue['topLegendHeight'] + spaceValue['bottomLegendHeight']);
        return { x: x, y: y, width: width, height: height };
    }
    getLegendSpace(smithchart, bounds) {
        const title = smithchart.title;
        const legend = smithchart.legendSettings;
        const position = legend.position.toLowerCase();
        let subtitleHeight = 0;
        let modelsubTitleHeight = 0;
        const titleHeight = 0;
        const font = smithchart.font;
        let modelTitleHeight = 0;
        const itemPadding = 10;
        const legendBorder = legend.border.width;
        let leftLegendWidth = 0;
        let rightLegendWidth = 0;
        let topLegendHeight = 0;
        let bottomLegendHeight = 0;
        let ltheight = 0;
        let space;
        if (legend['visible']) {
            space = (bounds.width + (itemPadding / 2) + smithchart.elementSpacing + (2 * legendBorder));
            leftLegendWidth = position === 'left' ? space : 0;
            rightLegendWidth = position === 'right' ? space : 0;
            ltheight = legend['title'].visible ? measureText(legend['title'].text, font)['height'] : 0;
            topLegendHeight = position === 'top' ? smithchart.elementSpacing + bounds.height + ltheight : 0;
            bottomLegendHeight = position === 'bottom' ? smithchart.elementSpacing + bounds.height + ltheight : 0;
        }
        subtitleHeight = measureText(title.subtitle.text, font)['height'];
        modelTitleHeight = (title.text === '' || !title['visible']) ? 0 : (titleHeight);
        modelsubTitleHeight = (title['subtitle'].text === '' || !title['subtitle'].visible) ? 0 : (subtitleHeight);
        return {
            leftLegendWidth: leftLegendWidth, rightLegendWidth: rightLegendWidth,
            topLegendHeight: topLegendHeight, bottomLegendHeight: bottomLegendHeight,
            modelTitleHeight: modelTitleHeight, modelsubTitleHeight: modelsubTitleHeight
        };
    }
}
